import React, { useEffect, useState } from "react";
import { Container, makeStyles, Box } from "@material-ui/core";
import Page from "src/components/Page";
import UsersList from "./UsersList";
import Toolbar from "./Toolbar";
import { useSelector, useDispatch } from "react-redux";
import { fetchAllUser } from "../../redux";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    minHeight: "100%",
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3),
  },
}));
const UserView = () => {
  const classes = useStyles();

  const [filterFn, setParentFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });
  const dispatch = useDispatch();
  let allFetchData = useSelector((state) => state.userAccount._allUsers) || [];

  useEffect(() => {
    dispatch(fetchAllUser());
    // eslint-disable-next-line
  }, []);

  let viewComponent;
  viewComponent = <UsersList TableData={allFetchData} filterFn={filterFn} />;

  return (
    <Page className={classes.root} title="Employee">
      <Container maxWidth={false}>
        <Toolbar setParentFilterFn={setParentFilterFn} />
        <Box mt={3}>{viewComponent}</Box>
      </Container>
    </Page>
  );
};

export default UserView;
